import SpotifyLogo from '@/../public/_n/images/dtc-partners/Spotify_Logo_White.png';

import { FlowConfig } from '../../Context/types';
import SpotifyScreensConfig from './Screens';

const SpotifyFlow: FlowConfig = {
	activeScreenKey: 'account',
	activeScreenConfig: SpotifyScreensConfig.account,
	coBranded: {
		src: SpotifyLogo,
		alt: 'Spotify Logo',
		// switching from next/legacy/image caused some sizing issues so this is to make sure it looks the same as before
		style: { width: 'auto', height: 38.52 },
	},
	name: 'spotify',
	pageName: 'link-with-spotify',
	screens: {
		account: SpotifyScreensConfig.account,
		payment: SpotifyScreensConfig.payment,
		handoff: SpotifyScreensConfig.handoff,
	},
	plan: 'yearly',
	promotion: 'spotify',
	hasFreeTrial: true,
	freeTrialLength: 30,
	offerCountries: null,
	offerCurrencies: null,
};

export default SpotifyFlow;
